module.exports = __webpack_public_path__ + "img/gd-central.13e2ed70.png";